export function parseResponse(cursor, data, parser, cb, person) {
    const hasNextPage = !!cursor;
    return {
        hasNextPage,
        data: parser(data),
        person,
        paginate() {
            return hasNextPage && cb();
        },
    };
}
